"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortTaetigkeitenAscending = void 0;
var sortTaetigkeitenAscending = exports.sortTaetigkeitenAscending = function sortTaetigkeitenAscending() {
  var taetigkeiten = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var copy = taetigkeiten.slice();
  copy.sort(function (a, b) {
    if (a.createdOn > b.createdOn) {
      return 1;
    }
    if (a.createdOn < b.createdOn) {
      return -1;
    }
    return 0;
  });
  return copy;
};